import { Box, styled, Typography } from '@mui/joy';

export const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
});

export const ContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  width: '50%',
  gap: 20,
});

export const Title = styled(Typography)({
  fontSize: 85,
});

export const SubTitle = styled(Typography)({
  fontWeight: 400,
});
